import { useQuery } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import { GetDisplayPreferenceTemplateQuery } from "~/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query GetDisplayPreferenceTemplate {
		getDisplayPreferenceTemplate {
			agent {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					width
				}
				form {
					info {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					addresses {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					contacts {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					service {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
				}
			}
			client {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					width
				}
				form {
					info {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					addresses {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					contacts {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					service {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
				}
			}
			product {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					width
				}
			}
			serviceAgent {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					width
				}
			}
			serviceClient {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					width
				}
			}
		}
	}
`;

export type GetDisplayPreferenceTemplateResults =
	GetDisplayPreferenceTemplateQuery["getDisplayPreferenceTemplate"];

export const getDisplayPreferenceTemplateQueryKey = () => [
	"getDisplayPreferenceTemplate",
];

export const useGetDisplayPreferenceTemplate = (enabled?: boolean) => {
	return useQuery({
		enabled: enabled ?? true,
		queryKey: getDisplayPreferenceTemplateQueryKey(),
		queryFn: async () =>
			apiGqlClient
				.request(graphql(query))
				.then((res) => res.getDisplayPreferenceTemplate),
	});
};

export const useGetDisplayPreferenceTemplateCache = () => {
	return useGetDisplayPreferenceTemplate(false);
};
